import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, spacing, radius, fonts, fontSize } = redesignTheme;

export const useVerifyPhoneFormStyles = makeStyles(() => ({
  otpCard: {
    width: '100%',
    backgroundColor: colors.otpCard,
    borderRadius: radius.sm,
    padding: `${spacing.lg}px ${spacing.sm}px`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.md,
  },
  resendLink: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.primary,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    textDecoration: 'underline',
    '&:hover:not(:disabled)': {
      opacity: 0.8,
    },
    '&:disabled': {
      color: colors.textSubtle,
      cursor: 'not-allowed',
      textDecoration: 'none',
      opacity: 0.7,
    },
  },
}));
